import { render, staticRenderFns } from "./AIAssistantFloatingButton.vue?vue&type=template&id=7f47336c&scoped=true"
import script from "./AIAssistantFloatingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AIAssistantFloatingButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AIAssistantFloatingButton.vue?vue&type=style&index=0&id=7f47336c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f47336c",
  null
  
)

export default component.exports